import api from 'api';

import { defaultPagination } from './general';

export const listRoles = async (params) => api().get('/roles', { params: { ...defaultPagination, ...params } });

export const getRole = async ({ id }) => api().get(`/roles/${id}`);

export const createRole = async ({ data }) => api().post('/roles', data);
export const updateRole = async ({ id, data }) => api().put(`/roles/${id}`, data);
